<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="card-title">Ortaggi</h4>
                </div>
                <div class="col-md-6">
                  <fg-input type="text"
                          label=""
                          placeholder="Cerca..."
                          v-model="pattern">
                  </fg-input>
                </div>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12 table-responsive">
                <l-table class="table-hover table-striped"
                         :columns="ortaggiColumns"
                         :data="ortaggi"
                         :url="url"
                         :pattern="pattern"
                         :getRowClass="ortaggiRowClass"
                         @onClick="onClick">
                </l-table>
              </div>
              <div class="col-md-12 text-right">
                <button type="button" class="btn btn-info btn-fill" @click.prevent="newOrtaggio">
                  Nuova Ortaggio
                </button>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  
  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        url: process.env.API_URL + 'ortaggio?withTrashed=true',
        ortaggiColumns: [
          {
            key: 'nome',
            text: 'Nome'
          }
        ],
        ortaggiRowClass: function (data) {
          return data.deleted_at ? 'text-danger' : ''
        },
        ortaggi: [],
        pattern: this.$route.params.pattern
      }
    },
    methods: {
      onClick: function (data) {
        this.$root.$router.push('/dashboard/ortaggio/' + data.id)
      },
      newOrtaggio: function () {
        this.$root.$router.push('/dashboard/ortaggio-new')
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/OrtaggioList.vue